import { Component, Inject, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';
import { TranslocoService } from '@jsverse/transloco';
import { AsteriskCallEvent, AsteriskNotifyService } from '@callcenter-app/service/asterisk-notify.service';
import { PushNotificationsService } from '@callcenter-app/service/push-notification.service';
import { CallStateService } from '@callcenter-app/service/call-state.service';
import { WORKPLACE_SHELL_ENABLED } from '@callcenter-app/service/workplace.config';
import { HxAuthService, NotifierService } from 'hx-services';
import { HeaderComponent } from '../../components/header/header.component';
import { SidebarComponent } from '../../components/sidebar/sidebar.component';
import { HcAlertComponent } from '../../components/hc-alert/hc-alert.component';
import { CallBarComponent } from '../../components/call-bar/call-bar.component';
import { CallLinkDialogComponent } from '../../components/call-link-dialog/call-link-dialog.component';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../../components/footer/footer.component';
import { environment } from '@callcenter-env/environment';
import { SHELL_V2_ENABLED } from '@callcenter-app/shell/shell.config';
import { ThemeService } from '@callcenter-app/shell/theme.service';
import { ShellSidebarComponent } from '@callcenter-app/shell/sidebar/shell-sidebar.component';
import { ShellHeaderComponent } from '@callcenter-app/shell/header/shell-header.component';
import { ShellNumberDialogComponent } from '@callcenter-app/shell/number-dialog/shell-number-dialog.component';

/**
 * Main page component
 */
@Component({
    selector: 'app-home.m-grid.m-grid--hor.m-grid--root.m-page',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    imports: [NgIf, HeaderComponent, SidebarComponent, HcAlertComponent, CallBarComponent, CallLinkDialogComponent, RouterOutlet, FooterComponent, ShellSidebarComponent, ShellHeaderComponent,
      ShellNumberDialogComponent]
})
export class HomeComponent implements OnInit {
  readonly isProd = environment.production;

  constructor(
    private callCenterService: AsteriskNotifyService,
    private pushNotification: PushNotificationsService,
    private tr: TranslocoService,
    private notifierService: NotifierService,
    private auth: HxAuthService,
    private callState: CallStateService,
    /** The shell of stage 4 (the switch `WORKPLACE_READY`): off — the page is as it was before the stage. */
    @Inject(WORKPLACE_SHELL_ENABLED) readonly shell: boolean,
    /** The new header and menu (the canvas «Шапка и меню — редизайн»); off — the Metronic shell, as it was. */
    @Inject(SHELL_V2_ENABLED) readonly shellV2: boolean,
    // started here in both shells: on, it follows the theme; off, it clears what `index.html` may have set
    private readonly theme: ThemeService,
  ) {
    tr.setDefaultLang('ru');
    tr.setActiveLang('ru');
  }

  ngOnInit() {
    this.pushNotification.requestPermission();
    if (this.shell) {
      // the one subscription to `operator.{number}` of the shell — and the old page is fed from it, as it always was
      this.callState.start();
    } else {
      this.feedOldPage();
    }
  }

  /** The shell is off: the bus is read here, for the old page only, exactly as the shell did not exist. */
  private feedOldPage(): void {
    const operatorId = this.auth.user.asteriskId;
    if (operatorId) {
      this.notifierService.eventBusOpenObs.subscribe(eb => {
        if (!eb) {
          return;
        }
        this.notifierService.registerHandler(`operator.${operatorId}`, (error, message) => {
          if (error) {
            console.error('error: ', error);
          } else if (message.body.clientPhone) {
            this.callCenterService.notify(message.body as AsteriskCallEvent);
          }
        });
      });
    }
  }
}
